import React from "react";
import Eyebrow from "@/components/Eyebrow";
import { FadeUp } from "@/components/Motion";

/**
 * Shared page-head component for inner pages (Trust/Compliance, Segments, etc.)
 */
export default function PageHeader({ eyebrow, title, lead, image, meta }) {
  return (
    <section className="relative rule-bottom" data-testid="page-header">
      <div className="container-editorial py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-7">
            {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
            <FadeUp as="h1" className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[0.98] mt-6 text-[#0C1D36]">
              {title}
            </FadeUp>
            {lead && (
              <FadeUp delay={0.1} className="mt-8 text-lg md:text-xl text-[#0C1D36]/80 leading-relaxed max-w-xl">
                {lead}
              </FadeUp>
            )}
            {meta && (
              <FadeUp delay={0.2} className="mt-10 pt-6 border-t border-[#0C1D36]/12 flex flex-wrap gap-x-10 gap-y-4">
                {meta.map((m) => (
                  <div key={m.label} className="min-w-[120px]">
                    <div className="eyebrow-muted">{m.label}</div>
                    <div className="font-serif text-2xl text-[#0C1D36] mt-1">{m.value}</div>
                  </div>
                ))}
              </FadeUp>
            )}
          </div>

          {image && (
            <div className="md:col-span-5 relative">
              <FadeUp delay={0.15} className="relative">
                <div className="aspect-[4/5] bg-[#F3EFE9] overflow-hidden border border-[#0C1D36]/10">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <span className="absolute -bottom-3 -left-3 w-16 h-16 bg-[#BA1A1A]" aria-hidden="true" />
              </FadeUp>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
